angular.module('rjmNg.constants').constant('ceDefaultDefinitions',
  column: Object.freeze
    data_type:
      type: "int"
    is_primary_key: false
    remote_column_id: 0
    currency_code: null
    is_paused: false
    state: "active"
    is_in_serving_layer: false
    is_in_raw_data_layer: false
    extra: ""
    table_id: 0
    recheck: "never"
    primary_key_index: 0
    is_derivative_recalc_required: false
    old_data_type: "INT"
    is_invalidation_required: false
    type: "derivative"
    is_referenceable: false
    reference_column_id: 0
    properties:
      character_set: 'utf8'
  field: Object.freeze
    name: ''
    id: null
    definition: null
    attrs:
      ref:
        table: null
        column: null
)
.constant('columnDataTypes',
  DECIMAL: 'decimal'
  FLOAT: 'float'
  INST: 'inst'
  INT: 'int'
  STRING: 'string'
)
.constant('dataTypeNames',
  decimal: 'DECIMAL'
  float: 'FLOAT'
  inst: 'DATETIME'
  int: 'INTEGER'
  string: 'TEXT'
)
.constant('derivativeTypes',
  aggregate: 20
  relocated_field: 36
  age: 29
  date_diff: 30
)
